var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49999 14.2198C11.6589 14.2198 14.2198 11.659 14.2198 8.5C14.2198 5.34105 11.6589 2.78021 8.49999 2.78021C5.34104 2.78021 2.7802 5.34105 2.7802 8.5C2.7802 11.659 5.34104 14.2198 8.49999 14.2198ZM8.49999 15.725C12.4903 15.725 15.725 12.4903 15.725 8.5C15.725 4.50974 12.4903 1.275 8.49999 1.275C4.50974 1.275 1.27499 4.50974 1.27499 8.5C1.27499 12.4903 4.50974 15.725 8.49999 15.725Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22499 7.0125C7.22499 7.59931 6.84444 8.075 6.37499 8.075C5.90555 8.075 5.52499 7.59931 5.52499 7.0125C5.52499 6.4257 5.90555 5.95 6.37499 5.95C6.84444 5.95 7.22499 6.4257 7.22499 7.0125Z",
    fill: "#2B2B2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.475 7.0125C11.475 7.59931 11.0944 8.075 10.625 8.075C10.1556 8.075 9.77499 7.59931 9.77499 7.0125C9.77499 6.4257 10.1556 5.95 10.625 5.95C11.0944 5.95 11.475 6.4257 11.475 7.0125Z",
    fill: "#2B2B2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09999 9.775C5.5949 11.2606 6.93029 12.325 8.49999 12.325C10.0697 12.325 11.4051 11.2606 11.9 9.775H5.09999Z",
    fill: "#2B2B2B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.0ad8383b330c7461acfbddc2289a7e61.svg";
export { ForwardRef as ReactComponent };